var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58984 2.07812H7.41016C7.48307 2.07812 7.51953 2.11458 7.51953 2.1875V11.8125C7.51953 11.8854 7.48307 11.9219 7.41016 11.9219H6.58984C6.51693 11.9219 6.48047 11.8854 6.48047 11.8125V2.1875C6.48047 2.11458 6.51693 2.07812 6.58984 2.07812Z",
    fill: "#1F9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 6.48047C11.8854 6.48047 11.9219 6.51693 11.9219 6.58984V7.41016C11.9219 7.48307 11.8854 7.51953 11.8125 7.51953H2.1875C2.11458 7.51953 2.07812 7.48307 2.07812 7.41016V6.58984C2.07812 6.51693 2.11458 6.48047 2.1875 6.48047H11.8125Z",
    fill: "#1F9C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOutlined);
export default __webpack_public_path__ + "static/media/PlusOutlined.592ddda6b1fc6f19b9efe01a6430f590.svg";
export { ForwardRef as ReactComponent };